import Loader from "app/components/Loader";
import * as React from "react";
import { lazyLoad } from "utils/loadable";

export const Features = lazyLoad(
  () => import("./index"),
  (module) => module.FeaturesPage,
  {
    fallback: <Loader />,
  }
);
